<template>

    <v-flex xs12 fill-height class="gmap-container">
        <googlemaps-map ref="gmap"
                        class="gmaps"
                        :center.sync="center"
                        :zoom.sync="zoom"
                        :options="gmapOptions"
                        @tilesloaded="onTilesLoadedMapCenterByMarkers">

            <!-- User Position -->
            <googlemaps-user-position
                    ref="userPosition"
                    v-if="enableUserPosition"
                    :positionStyle="{
                    url: marker_user_position,
                    scaledSize: {width: 40, height: 40, l: undefined, j: undefined}
                    }"
                    @update:position="setUserPosition">
            </googlemaps-user-position>

            <googlemaps-marker
                    v-for="marker of markers"
                    :key="marker.id"
                    :icon="{
                    url: marker.state === 'READY' ? marker_image_ready : marker_image_offline,
                    scaledSize: {width: 30, height: 45, l: undefined, j: undefined}
                    }"
                    :position="{lat: marker.lat, lng: marker.lng}"
                    @click="openPopupMarker(marker.sgid)"
            ></googlemaps-marker>
        </googlemaps-map>

        <transition name="fade-transition">
            <pop-up-station :station-sgid="selectedStation"
                            v-if="selectedStation"
                            @close="selectedStation= null">
            </pop-up-station>
        </transition>
    </v-flex>

</template>

<script>

    import marker_image_ready from "../assets/markerpng.png"
    import marker_image_offline from "../assets/markeroffline.png"
    import marker_user_position from "../assets/gps_marker.png"
    import PopUpStation from "./PopUpStation"


    export default {
        data() {
            return {
                selectedStation: null,
                marker_image_ready,
                marker_image_offline,
                marker_user_position,
                userPosition: {
                    lat: 0,
                    lng: 0
                },
                gmapOptions: {
                    mapTypeControl: false,
                    fullscreenControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    zoomControl: false,
                    styles: [
                        {
                            elementType: 'geometry',
                            stylers: [{color: '#44554F'}]
                        },
                        {
                            elementType: 'labels.text.stroke',
                            stylers: [{color: '#242f3e'}]
                        },
                        {
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#746855'}]
                        },
                        {
                            featureType: 'administrative.locality',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#d59563'}]
                        },
                        {
                            featureType: 'landscape',
                            elementType: 'labels',
                            stylers: [
                                {visibility: 'off'}
                            ]
                        },
                        {
                            featureType: 'poi',
                            elementType: 'labels.text.fill',
                            stylers: [{visibility: "off"}]
                        },
                        {
                            featureType: 'poi',
                            elementType: 'labels',
                            stylers: [{visibility: "off"}]
                        },
                        {
                            featureType: 'road',
                            elementType: 'geometry',
                            stylers: [{color: '#8A9793'}]
                        },
                        {
                            featureType: 'road',
                            elementType: 'geometry.stroke',
                            stylers: [{color: '#212a37'}]
                        },
                        {
                            featureType: 'road',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#9ca5b3'}]
                        },
                        {
                            featureType: 'road.highway',
                            elementType: 'geometry',
                            stylers: [{color: '#746855'}]
                        },
                        {
                            featureType: 'road.highway',
                            elementType: 'geometry.stroke',
                            stylers: [{color: '#1f2835'}]
                        },
                        {
                            featureType: 'road.highway',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#f3d19c'}]
                        },
                        {
                            featureType: 'transit',
                            elementType: 'geometry',
                            stylers: [{color: '#2f3948'}]
                        },
                        {
                            featureType: 'transit.station',
                            elementType: 'labels',
                            stylers: [{visibility: "off"}]
                        },
                        {
                            featureType: 'water',
                            elementType: 'geometry',
                            stylers: [{color: '#17263c'}]
                        },
                        {
                            featureType: 'water',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#515c6d'}]
                        },
                        {
                            featureType: 'water',
                            elementType: 'labels.text.stroke',
                            stylers: [{color: '#17263c'}]
                        }
                    ]

                },
                zoom: 16,
                center: {
                    lat: 0,
                    lng: 0
                },
                mapBounds: null
            }
        },
        watch: {
            initialZoom: function (val) {
                this.zoom = val
            },
            initialCenter(val) {
                this.center = val

            },
            userPosition: {
                handler: function (val) {
                    if (this.enableUserPosition) {
                        this.center = val

                    }

                },
                deep: true

            }

        },
        created() {
            this.centeredBymarkers = false
        },
        props: {
            initialZoom: Number,
            initialCenter: Object,
            markers: Array,
            enableUserPosition: Boolean
        },
        methods: {
            setUserPosition(position) {
                this.userPosition = position
            },
            openPopupMarker(sgid) {
                this.selectedStation = sgid
            },
            onTilesLoadedMapCenterByMarkers() {
                if (!this.centeredBymarkers && this.markers.length !== 0) {

                    if (!this.enableUserPosition) {

                        const map = this.$refs.gmap

                        const firstMarkerPosition = new window.google.maps.LatLng(this.markers[0].lat, this.markers[0].lng)
                        map.panTo(firstMarkerPosition)

                        let bounds = map.getBounds()
                        this.markers.forEach((m) => {
                            const loc = new window.google.maps.LatLng(m.lat, m.lng)
                            bounds.extend(loc)
                        })
                        map.fitBounds(bounds)
                        map.panToBounds(bounds)
                        this.centeredBymarkers = true
                    }

                }

            }
        },
        components: {
            PopUpStation
        }
    }
</script>


<style scoped lang="scss">

    .gmap-container{
        overflow: hidden;

        .gmaps {
            width: 100%;
            height: 110%;
        }

    }



</style>
